import React, { useCallback } from 'react';
import { Collapse, ListItemButton, ListItemText, Typography } from '@mui/material';
import { ExpandLess } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BPStatusObject } from '../../app/store/questionnaireAnswerSlice';

const CollapsibleListItem = React.memo((properties: {
  isParentRemediation?: boolean,
  item: any, 
  setActive: any, 
  active: any, 
  children?: any,
  cantCollapse?: boolean, 
  idx: number, 
  onClick?: any, 
  pl?: number, 
  pr?: number,
  titleOverride?: string 
  typographyProps: any
  filteredQuestionsCount?: number
  currentBpStatusObject?: BPStatusObject
}) => {
  const {
    currentBpStatusObject,
    item,
    setActive,
    active,
    children,
    cantCollapse,
    idx,
    onClick,
    pl,
    pr,
    titleOverride,
    typographyProps,
    isParentRemediation,
    filteredQuestionsCount,
  } = properties;

  const handleClick = useCallback(() => {
    setActive(item.id);
    if (onClick) {
      onClick();
    }
  }, [setActive, item.id, onClick]);

  return (
      <>
        <ListItemButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClick(); }}>
          <ListItemText
            primaryTypographyProps={cantCollapse ? typographyProps(item.id, isParentRemediation) : {}}
            sx={{ pl: pl, pr: pr }}
            primary={titleOverride ? titleOverride : (item.hasOwnProperty('code') ? item.code : idx) + '. ' + item.title}
          />
          {!cantCollapse ? active === item.id ? <ExpandLess /> : <ExpandMoreIcon /> : null}
          {cantCollapse && !titleOverride && currentBpStatusObject ? <Typography sx={typographyProps(item.id, isParentRemediation)}>{currentBpStatusObject.questionsAnsweredCount + '/' + (filteredQuestionsCount && filteredQuestionsCount < currentBpStatusObject.visibleQuestionsCount ?  filteredQuestionsCount : currentBpStatusObject.visibleQuestionsCount)}</Typography> : null}
        </ListItemButton>
        {!cantCollapse &&
          <Collapse in={active === item.id} timeout="auto" unmountOnExit>
            {children}
          </Collapse>
        }
      </>
  );
}, (prevProps, nextProps) => {
  return prevProps.item.id === nextProps.item.id &&
    prevProps.active === nextProps.active &&
    prevProps.children === nextProps.children &&
    prevProps.cantCollapse === nextProps.cantCollapse &&
    prevProps.idx === nextProps.idx &&
    prevProps.pl === nextProps.pl &&
    prevProps.pr === nextProps.pr &&
    prevProps.titleOverride === nextProps.titleOverride &&
    prevProps.isParentRemediation === nextProps.isParentRemediation &&
    prevProps.filteredQuestionsCount === nextProps.filteredQuestionsCount &&
    prevProps.typographyProps === nextProps.typographyProps &&
    prevProps.currentBpStatusObject?.questionsAnsweredCount === nextProps.currentBpStatusObject?.questionsAnsweredCount &&
    prevProps.currentBpStatusObject?.visibleQuestionsCount === nextProps.currentBpStatusObject?.visibleQuestionsCount;
});

export default CollapsibleListItem;